"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParentContainerSize = void 0;

var getParentContainerSize = function getParentContainerSize(img) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'width';
  var parentNode = img;
  var size = 0;
  var maxCount = 0;

  do {
    parentNode = parentNode && parentNode.parentNode;
    size = typeof parentNode.getBoundingClientRect === 'function' ? parentNode.getBoundingClientRect()[type] : window.innerWidth;
    maxCount = maxCount + 1;
  } while (parentNode && !size && maxCount > 5);

  var leftPadding = size && parentNode && parentNode.nodeType === 1 ? parseInt(window.getComputedStyle(parentNode).paddingLeft) : 0;
  var rightPadding = size && parentNode && parentNode.nodeType === 1 ? parseInt(window.getComputedStyle(parentNode).paddingRight) : 0;

  if (!size) {
    size = window.innerWidth;
  }

  return size + (size ? -leftPadding - rightPadding : 0);
};

exports.getParentContainerSize = getParentContainerSize;